const StatData = [
  {
    match_id: 7175981,
    team_id: 468231,
    player_id: 17209,
    minutes_played: 132.22,
    team_possession_percentage: 0.55,
    xg: 0.02,
    shots: 1,
    goals: 0,
    tackles: 0,
    interceptions: 0,
    pressures: 3,
    passes: 76,
    completed_passes: 54,
    left_foot_passes: 6,
    right_foot_passes: 39,
    player_shots_faced: 0
  },
  {
    match_id: 7175982,
    team_id: 468227,
    player_id: 15970,
    minutes_played: 97.63,
    team_possession_percentage: 0.37,
    xg: 0.22,
    shots: 1,
    goals: 1,
    tackles: 0,
    interceptions: 0,
    pressures: 4,
    passes: 34,
    completed_passes: 28,
    left_foot_passes: 22,
    right_foot_passes: 4,
    player_shots_faced: 0
  },
  {
    match_id: 7175982,
    team_id: 468240,
    player_id: 8183,
    minutes_played: 97.63,
    team_possession_percentage: 0.63,
    xg: 0.01,
    shots: 1,
    goals: 0,
    tackles: 0,
    interceptions: 1,
    pressures: 12,
    passes: 58,
    completed_passes: 57,
    left_foot_passes: 3,
    right_foot_passes: 51,
    player_shots_faced: 0
  },
  {
    match_id: 7175937,
    team_id: 468245,
    player_id: 1966,
    minutes_played: 127.62,
    team_possession_percentage: 0.47,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 1,
    interceptions: 2,
    pressures: 10,
    passes: 54,
    completed_passes: 38,
    left_foot_passes: 1,
    right_foot_passes: 23,
    player_shots_faced: 0
  },
  {
    match_id: 7175975,
    team_id: 468226,
    player_id: 7537,
    minutes_played: 26.03,
    team_possession_percentage: 0.22,
    xg: 0.06,
    shots: 1,
    goals: 0,
    tackles: 0,
    interceptions: 0,
    pressures: 10,
    passes: 2,
    completed_passes: 2,
    left_foot_passes: 0,
    right_foot_passes: 2,
    player_shots_faced: 0
  },
  {
    match_id: 7175937,
    team_id: 468245,
    player_id: 8546,
    minutes_played: 127.62,
    team_possession_percentage: 0.47,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 0,
    interceptions: 0,
    pressures: 0,
    passes: 46,
    completed_passes: 29,
    left_foot_passes: 1,
    right_foot_passes: 21,
    player_shots_faced: 5
  },
  {
    match_id: 7175937,
    team_id: 468245,
    player_id: 14889,
    minutes_played: 127.62,
    team_possession_percentage: 0.47,
    xg: 0.1,
    shots: 1,
    goals: 1,
    tackles: 0,
    interceptions: 1,
    pressures: 5,
    passes: 68,
    completed_passes: 58,
    left_foot_passes: 5,
    right_foot_passes: 52,
    player_shots_faced: 0
  },
  {
    match_id: 7175937,
    team_id: 468231,
    player_id: 17209,
    minutes_played: 127.62,
    team_possession_percentage: 0.53,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 0,
    interceptions: 0,
    pressures: 4,
    passes: 61,
    completed_passes: 45,
    left_foot_passes: 2,
    right_foot_passes: 34,
    player_shots_faced: 0
  },
  {
    match_id: 7175937,
    team_id: 468245,
    player_id: 17690,
    minutes_played: 127.62,
    team_possession_percentage: 0.47,
    xg: 0.14,
    shots: 3,
    goals: 0,
    tackles: 0,
    interceptions: 1,
    pressures: 29,
    passes: 54,
    completed_passes: 39,
    left_foot_passes: 11,
    right_foot_passes: 26,
    player_shots_faced: 0
  },
  {
    match_id: 7175937,
    team_id: 468231,
    player_id: 289719,
    minutes_played: 73.22,
    team_possession_percentage: 0.53,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 2,
    interceptions: 1,
    pressures: 14,
    passes: 51,
    completed_passes: 43,
    left_foot_passes: 3,
    right_foot_passes: 39,
    player_shots_faced: 0
  },
  {
    match_id: 7175937,
    team_id: 468245,
    player_id: 297753,
    minutes_played: 47.18,
    team_possession_percentage: 0.47,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 1,
    interceptions: 0,
    pressures: 4,
    passes: 23,
    completed_passes: 19,
    left_foot_passes: 1,
    right_foot_passes: 17,
    player_shots_faced: 0
  },
  {
    match_id: 7175937,
    team_id: 468231,
    player_id: 4891316,
    minutes_played: 127.62,
    team_possession_percentage: 0.53,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 0,
    interceptions: 2,
    pressures: 10,
    passes: 76,
    completed_passes: 63,
    left_foot_passes: 12,
    right_foot_passes: 47,
    player_shots_faced: 0
  },
  {
    match_id: 7175937,
    team_id: 468245,
    player_id: 5568520,
    minutes_played: 16.13,
    team_possession_percentage: 0.47,
    xg: 0.02,
    shots: 1,
    goals: 0,
    tackles: 0,
    interceptions: 0,
    pressures: 2,
    passes: 5,
    completed_passes: 4,
    left_foot_passes: 0,
    right_foot_passes: 4,
    player_shots_faced: 0
  },
  {
    match_id: 7175942,
    team_id: 468240,
    player_id: 1187,
    minutes_played: 12.93,
    team_possession_percentage: 0.42,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 0,
    interceptions: 0,
    pressures: 0,
    passes: 5,
    completed_passes: 5,
    left_foot_passes: 5,
    right_foot_passes: 0,
    player_shots_faced: 0
  },
  {
    match_id: 7175942,
    team_id: 468240,
    player_id: 1599,
    minutes_played: 96.3,
    team_possession_percentage: 0.42,
    xg: 0.03,
    shots: 1,
    goals: 0,
    tackles: 1,
    interceptions: 0,
    pressures: 9,
    passes: 44,
    completed_passes: 41,
    left_foot_passes: 3,
    right_foot_passes: 38,
    player_shots_faced: 0
  },
  {
    match_id: 7175942,
    team_id: 468237,
    player_id: 11577,
    minutes_played: 73.32,
    team_possession_percentage: 0.58,
    xg: 0.48,
    shots: 3,
    goals: 0,
    tackles: 2,
    interceptions: 0,
    pressures: 17,
    passes: 33,
    completed_passes: 29,
    left_foot_passes: 1,
    right_foot_passes: 28,
    player_shots_faced: 0
  },
  {
    match_id: 7175942,
    team_id: 468237,
    player_id: 12203,
    minutes_played: 96.3,
    team_possession_percentage: 0.58,
    xg: 0.33,
    shots: 3,
    goals: 0,
    tackles: 1,
    interceptions: 0,
    pressures: 13,
    passes: 60,
    completed_passes: 51,
    left_foot_passes: 4,
    right_foot_passes: 44,
    player_shots_faced: 0
  },
  {
    match_id: 7175942,
    team_id: 468240,
    player_id: 13348,
    minutes_played: 96.3,
    team_possession_percentage: 0.42,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 0,
    interceptions: 0,
    pressures: 0,
    passes: 30,
    completed_passes: 17,
    left_foot_passes: 9,
    right_foot_passes: 3,
    player_shots_faced: 9
  },
  {
    match_id: 7175942,
    team_id: 468240,
    player_id: 13975,
    minutes_played: 8.53,
    team_possession_percentage: 0.42,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 0,
    interceptions: 0,
    pressures: 7,
    passes: 1,
    completed_passes: 1,
    left_foot_passes: 0,
    right_foot_passes: 1,
    player_shots_faced: 0
  },
  {
    match_id: 7175942,
    team_id: 468240,
    player_id: 15289,
    minutes_played: 87.77,
    team_possession_percentage: 0.42,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 0,
    interceptions: 0,
    pressures: 14,
    passes: 13,
    completed_passes: 9,
    left_foot_passes: 7,
    right_foot_passes: 0,
    player_shots_faced: 0
  },
  {
    match_id: 7175944,
    team_id: 468217,
    player_id: 1562,
    minutes_played: 95.18,
    team_possession_percentage: 0.58,
    xg: 0.01,
    shots: 1,
    goals: 0,
    tackles: 3,
    interceptions: 3,
    pressures: 30,
    passes: 79,
    completed_passes: 74,
    left_foot_passes: 46,
    right_foot_passes: 25,
    player_shots_faced: 0
  },
  {
    match_id: 7175944,
    team_id: 468217,
    player_id: 5647,
    minutes_played: 95.18,
    team_possession_percentage: 0.58,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 1,
    interceptions: 1,
    pressures: 33,
    passes: 99,
    completed_passes: 80,
    left_foot_passes: 2,
    right_foot_passes: 70,
    player_shots_faced: 0
  },
  {
    match_id: 7175944,
    team_id: 468240,
    player_id: 14140,
    minutes_played: 95.18,
    team_possession_percentage: 0.42,
    xg: 0.13,
    shots: 2,
    goals: 0,
    tackles: 1,
    interceptions: 0,
    pressures: 30,
    passes: 64,
    completed_passes: 54,
    left_foot_passes: 7,
    right_foot_passes: 47,
    player_shots_faced: 0
  },
  {
    match_id: 7175944,
    team_id: 468240,
    player_id: 14249,
    minutes_played: 95.18,
    team_possession_percentage: 0.42,
    xg: 0.44,
    shots: 2,
    goals: 1,
    tackles: 0,
    interceptions: 0,
    pressures: 20,
    passes: 58,
    completed_passes: 43,
    left_foot_passes: 5,
    right_foot_passes: 37,
    player_shots_faced: 0
  },
  {
    match_id: 7175944,
    team_id: 468240,
    player_id: 19612,
    minutes_played: 95.18,
    team_possession_percentage: 0.42,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 0,
    interceptions: 1,
    pressures: 35,
    passes: 49,
    completed_passes: 42,
    left_foot_passes: 26,
    right_foot_passes: 11,
    player_shots_faced: 0
  },
  {
    match_id: 7175944,
    team_id: 468240,
    player_id: 19755,
    minutes_played: 15.28,
    team_possession_percentage: 0.42,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 1,
    interceptions: 0,
    pressures: 8,
    passes: 10,
    completed_passes: 10,
    left_foot_passes: 9,
    right_foot_passes: 1,
    player_shots_faced: 0
  },
  {
    match_id: 7175944,
    team_id: 468217,
    player_id: 296172,
    minutes_played: 95.18,
    team_possession_percentage: 0.58,
    xg: 0.11,
    shots: 3,
    goals: 0,
    tackles: 0,
    interceptions: 3,
    pressures: 18,
    passes: 60,
    completed_passes: 58,
    left_foot_passes: 5,
    right_foot_passes: 51,
    player_shots_faced: 0
  },
  {
    match_id: 7175944,
    team_id: 468217,
    player_id: 300386,
    minutes_played: 9.6,
    team_possession_percentage: 0.58,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 0,
    interceptions: 0,
    pressures: 6,
    passes: 6,
    completed_passes: 5,
    left_foot_passes: 0,
    right_foot_passes: 5,
    player_shots_faced: 0
  },
  {
    match_id: 7175946,
    team_id: 468239,
    player_id: 3424,
    minutes_played: 97.05,
    team_possession_percentage: 0.6,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 0,
    interceptions: 0,
    pressures: 0,
    passes: 20,
    completed_passes: 15,
    left_foot_passes: 3,
    right_foot_passes: 11,
    player_shots_faced: 3
  },
  {
    match_id: 7175946,
    team_id: 468227,
    player_id: 13509,
    minutes_played: 97.05,
    team_possession_percentage: 0.4,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 3,
    interceptions: 2,
    pressures: 43,
    passes: 18,
    completed_passes: 14,
    left_foot_passes: 12,
    right_foot_passes: 0,
    player_shots_faced: 0
  },
  {
    match_id: 7175946,
    team_id: 468239,
    player_id: 19364,
    minutes_played: 97.05,
    team_possession_percentage: 0.6,
    xg: 0.44,
    shots: 3,
    goals: 1,
    tackles: 1,
    interceptions: 0,
    pressures: 18,
    passes: 26,
    completed_passes: 14,
    left_foot_passes: 11,
    right_foot_passes: 0,
    player_shots_faced: 0
  },
  {
    match_id: 7175946,
    team_id: 468227,
    player_id: 19761,
    minutes_played: 84.93,
    team_possession_percentage: 0.4,
    xg: 0.36,
    shots: 2,
    goals: 1,
    tackles: 1,
    interceptions: 0,
    pressures: 26,
    passes: 19,
    completed_passes: 13,
    left_foot_passes: 11,
    right_foot_passes: 2,
    player_shots_faced: 0
  },
  {
    match_id: 7175946,
    team_id: 468239,
    player_id: 5568511,
    minutes_played: 97.05,
    team_possession_percentage: 0.6,
    xg: 0.02,
    shots: 1,
    goals: 0,
    tackles: 3,
    interceptions: 2,
    pressures: 33,
    passes: 63,
    completed_passes: 54,
    left_foot_passes: 5,
    right_foot_passes: 49,
    player_shots_faced: 0
  },
  {
    match_id: 7175951,
    team_id: 468240,
    player_id: 1599,
    minutes_played: 96.25,
    team_possession_percentage: 0.58,
    xg: 0.5,
    shots: 5,
    goals: 0,
    tackles: 1,
    interceptions: 0,
    pressures: 3,
    passes: 83,
    completed_passes: 76,
    left_foot_passes: 4,
    right_foot_passes: 71,
    player_shots_faced: 0
  },
  {
    match_id: 7175951,
    team_id: 468241,
    player_id: 10771,
    minutes_played: 14.58,
    team_possession_percentage: 0.42,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 0,
    interceptions: 0,
    pressures: 2,
    passes: 6,
    completed_passes: 5,
    left_foot_passes: 0,
    right_foot_passes: 5,
    player_shots_faced: 0
  },
  {
    match_id: 7175951,
    team_id: 468240,
    player_id: 13348,
    minutes_played: 96.25,
    team_possession_percentage: 0.58,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 0,
    interceptions: 0,
    pressures: 0,
    passes: 21,
    completed_passes: 19,
    left_foot_passes: 8,
    right_foot_passes: 5,
    player_shots_faced: 4
  },
  {
    match_id: 7175951,
    team_id: 468241,
    player_id: 14164,
    minutes_played: 81.8,
    team_possession_percentage: 0.42,
    xg: 0.25,
    shots: 2,
    goals: 1,
    tackles: 1,
    interceptions: 1,
    pressures: 17,
    passes: 24,
    completed_passes: 21,
    left_foot_passes: 2,
    right_foot_passes: 19,
    player_shots_faced: 0
  },
  {
    match_id: 7175951,
    team_id: 468240,
    player_id: 15289,
    minutes_played: 96.25,
    team_possession_percentage: 0.58,
    xg: 0.85,
    shots: 7,
    goals: 0,
    tackles: 0,
    interceptions: 0,
    pressures: 11,
    passes: 19,
    completed_passes: 15,
    left_foot_passes: 7,
    right_foot_passes: 8,
    player_shots_faced: 0
  },
  {
    match_id: 7175951,
    team_id: 468241,
    player_id: 17181,
    minutes_played: 96.25,
    team_possession_percentage: 0.42,
    xg: 0.03,
    shots: 1,
    goals: 0,
    tackles: 1,
    interceptions: 0,
    pressures: 17,
    passes: 58,
    completed_passes: 51,
    left_foot_passes: 6,
    right_foot_passes: 45,
    player_shots_faced: 0
  },
  {
    match_id: 7175951,
    team_id: 468241,
    player_id: 18118,
    minutes_played: 96.25,
    team_possession_percentage: 0.42,
    xg: 0.05,
    shots: 2,
    goals: 0,
    tackles: 0,
    interceptions: 1,
    pressures: 9,
    passes: 49,
    completed_passes: 41,
    left_foot_passes: 17,
    right_foot_passes: 19,
    player_shots_faced: 0
  },
  {
    match_id: 7175951,
    team_id: 468240,
    player_id: 21226,
    minutes_played: 65.43,
    team_possession_percentage: 0.58,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 0,
    interceptions: 0,
    pressures: 22,
    passes: 25,
    completed_passes: 20,
    left_foot_passes: 2,
    right_foot_passes: 18,
    player_shots_faced: 0
  },
  {
    match_id: 7175951,
    team_id: 468241,
    player_id: 23606,
    minutes_played: 96.25,
    team_possession_percentage: 0.42,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 1,
    interceptions: 3,
    pressures: 14,
    passes: 40,
    completed_passes: 29,
    left_foot_passes: 2,
    right_foot_passes: 23,
    player_shots_faced: 0
  },
  {
    match_id: 7175952,
    team_id: 468227,
    player_id: 15970,
    minutes_played: 97.05,
    team_possession_percentage: 0.62,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 0,
    interceptions: 1,
    pressures: 5,
    passes: 26,
    completed_passes: 19,
    left_foot_passes: 13,
    right_foot_passes: 5,
    player_shots_faced: 0
  },
  {
    match_id: 7175952,
    team_id: 468227,
    player_id: 288702,
    minutes_played: 97.05,
    team_possession_percentage: 0.62,
    xg: 0.01,
    shots: 1,
    goals: 0,
    tackles: 3,
    interceptions: 1,
    pressures: 11,
    passes: 84,
    completed_passes: 72,
    left_foot_passes: 4,
    right_foot_passes: 56,
    player_shots_faced: 0
  },
  {
    match_id: 7175960,
    team_id: 468231,
    player_id: 1163,
    minutes_played: 131.05,
    team_possession_percentage: 0.65,
    xg: 0.13,
    shots: 3,
    goals: 1,
    tackles: 2,
    interceptions: 0,
    pressures: 9,
    passes: 110,
    completed_passes: 90,
    left_foot_passes: 11,
    right_foot_passes: 79,
    player_shots_faced: 0
  },
  {
    match_id: 7175960,
    team_id: 468226,
    player_id: 2561,
    minutes_played: 62.55,
    team_possession_percentage: 0.35,
    xg: 0.03,
    shots: 1,
    goals: 0,
    tackles: 1,
    interceptions: 0,
    pressures: 11,
    passes: 14,
    completed_passes: 10,
    left_foot_passes: 1,
    right_foot_passes: 8,
    player_shots_faced: 0
  },
  {
    match_id: 7175960,
    team_id: 468226,
    player_id: 2784,
    minutes_played: 131.05,
    team_possession_percentage: 0.35,
    xg: 0.19,
    shots: 1,
    goals: 1,
    tackles: 3,
    interceptions: 0,
    pressures: 16,
    passes: 55,
    completed_passes: 38,
    left_foot_passes: 1,
    right_foot_passes: 26,
    player_shots_faced: 0
  },
  {
    match_id: 7175960,
    team_id: 468226,
    player_id: 2915,
    minutes_played: 22.13,
    team_possession_percentage: 0.35,
    xg: 0,
    shots: 0,
    goals: 1,
    tackles: 0,
    interceptions: 0,
    pressures: 7,
    passes: 11,
    completed_passes: 6,
    left_foot_passes: 0,
    right_foot_passes: 6,
    player_shots_faced: 0
  },
  {
    match_id: 7175960,
    team_id: 468226,
    player_id: 6782,
    minutes_played: 131.05,
    team_possession_percentage: 0.35,
    xg: 0.06,
    shots: 1,
    goals: 1,
    tackles: 1,
    interceptions: 0,
    pressures: 28,
    passes: 33,
    completed_passes: 25,
    left_foot_passes: 3,
    right_foot_passes: 19,
    player_shots_faced: 0
  },
  {
    match_id: 7175960,
    team_id: 468231,
    player_id: 16743,
    minutes_played: 131.05,
    team_possession_percentage: 0.65,
    xg: 0.15,
    shots: 3,
    goals: 0,
    tackles: 0,
    interceptions: 0,
    pressures: 18,
    passes: 24,
    completed_passes: 9,
    left_foot_passes: 0,
    right_foot_passes: 9,
    player_shots_faced: 0
  },
  {
    match_id: 7175960,
    team_id: 468231,
    player_id: 18157,
    minutes_played: 131.05,
    team_possession_percentage: 0.65,
    xg: 0.01,
    shots: 1,
    goals: 0,
    tackles: 0,
    interceptions: 1,
    pressures: 4,
    passes: 92,
    completed_passes: 77,
    left_foot_passes: 19,
    right_foot_passes: 51,
    player_shots_faced: 0
  },
  {
    match_id: 7175960,
    team_id: 468231,
    player_id: 18277,
    minutes_played: 41.12,
    team_possession_percentage: 0.65,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 1,
    interceptions: 0,
    pressures: 10,
    passes: 10,
    completed_passes: 8,
    left_foot_passes: 1,
    right_foot_passes: 7,
    player_shots_faced: 0
  },
  {
    match_id: 7175960,
    team_id: 468226,
    player_id: 291054,
    minutes_played: 131.05,
    team_possession_percentage: 0.35,
    xg: 0.16,
    shots: 1,
    goals: 0,
    tackles: 0,
    interceptions: 1,
    pressures: 3,
    passes: 39,
    completed_passes: 28,
    left_foot_passes: 6,
    right_foot_passes: 20,
    player_shots_faced: 0
  },
  {
    match_id: 7175960,
    team_id: 468231,
    player_id: 5091570,
    minutes_played: 55.43,
    team_possession_percentage: 0.65,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 0,
    interceptions: 0,
    pressures: 3,
    passes: 45,
    completed_passes: 34,
    left_foot_passes: 23,
    right_foot_passes: 0,
    player_shots_faced: 0
  },
  {
    match_id: 7175972,
    team_id: 468236,
    player_id: 4754,
    minutes_played: 14.6,
    team_possession_percentage: 0.33,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 0,
    interceptions: 0,
    pressures: 3,
    passes: 3,
    completed_passes: 3,
    left_foot_passes: 0,
    right_foot_passes: 2,
    player_shots_faced: 0
  },
  {
    match_id: 7175972,
    team_id: 468236,
    player_id: 6864,
    minutes_played: 97.65,
    team_possession_percentage: 0.33,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 0,
    interceptions: 0,
    pressures: 0,
    passes: 24,
    completed_passes: 12,
    left_foot_passes: 0,
    right_foot_passes: 9,
    player_shots_faced: 3
  },
  {
    match_id: 7175972,
    team_id: 468236,
    player_id: 7171,
    minutes_played: 83.25,
    team_possession_percentage: 0.33,
    xg: 0.21,
    shots: 3,
    goals: 1,
    tackles: 1,
    interceptions: 1,
    pressures: 29,
    passes: 24,
    completed_passes: 19,
    left_foot_passes: 0,
    right_foot_passes: 19,
    player_shots_faced: 0
  },
  {
    match_id: 7175972,
    team_id: 468236,
    player_id: 13912,
    minutes_played: 97.65,
    team_possession_percentage: 0.33,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 0,
    interceptions: 0,
    pressures: 3,
    passes: 28,
    completed_passes: 22,
    left_foot_passes: 1,
    right_foot_passes: 17,
    player_shots_faced: 0
  },
  {
    match_id: 7175972,
    team_id: 468238,
    player_id: 19759,
    minutes_played: 97.65,
    team_possession_percentage: 0.67,
    xg: 0.05,
    shots: 1,
    goals: 0,
    tackles: 0,
    interceptions: 0,
    pressures: 12,
    passes: 15,
    completed_passes: 11,
    left_foot_passes: 2,
    right_foot_passes: 8,
    player_shots_faced: 0
  },
  {
    match_id: 7175972,
    team_id: 468236,
    player_id: 3304738,
    minutes_played: 91.62,
    team_possession_percentage: 0.33,
    xg: 0.26,
    shots: 3,
    goals: 0,
    tackles: 1,
    interceptions: 0,
    pressures: 47,
    passes: 22,
    completed_passes: 14,
    left_foot_passes: 2,
    right_foot_passes: 8,
    player_shots_faced: 0
  },
  {
    match_id: 7175972,
    team_id: 468236,
    player_id: 4876494,
    minutes_played: 83.25,
    team_possession_percentage: 0.33,
    xg: 0.02,
    shots: 1,
    goals: 0,
    tackles: 1,
    interceptions: 0,
    pressures: 25,
    passes: 35,
    completed_passes: 18,
    left_foot_passes: 0,
    right_foot_passes: 13,
    player_shots_faced: 0
  },
  {
    match_id: 7175975,
    team_id: 468226,
    player_id: 2561,
    minutes_played: 62.37,
    team_possession_percentage: 0.22,
    xg: 0.03,
    shots: 1,
    goals: 1,
    tackles: 1,
    interceptions: 0,
    pressures: 16,
    passes: 13,
    completed_passes: 9,
    left_foot_passes: 0,
    right_foot_passes: 8,
    player_shots_faced: 0
  },
  {
    match_id: 7175975,
    team_id: 468226,
    player_id: 2784,
    minutes_played: 128.55,
    team_possession_percentage: 0.22,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 1,
    interceptions: 7,
    pressures: 30,
    passes: 63,
    completed_passes: 44,
    left_foot_passes: 2,
    right_foot_passes: 30,
    player_shots_faced: 0
  },
  {
    match_id: 7175975,
    team_id: 468226,
    player_id: 3260,
    minutes_played: 47.13,
    team_possession_percentage: 0.22,
    xg: 0.01,
    shots: 1,
    goals: 0,
    tackles: 1,
    interceptions: 1,
    pressures: 4,
    passes: 11,
    completed_passes: 9,
    left_foot_passes: 6,
    right_foot_passes: 1,
    player_shots_faced: 0
  },
  {
    match_id: 7175975,
    team_id: 468226,
    player_id: 6782,
    minutes_played: 102.52,
    team_possession_percentage: 0.22,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 3,
    interceptions: 3,
    pressures: 24,
    passes: 21,
    completed_passes: 18,
    left_foot_passes: 4,
    right_foot_passes: 14,
    player_shots_faced: 0
  },
  {
    match_id: 7175975,
    team_id: 468246,
    player_id: 13558,
    minutes_played: 128.55,
    team_possession_percentage: 0.78,
    xg: 0.01,
    shots: 1,
    goals: 0,
    tackles: 3,
    interceptions: 0,
    pressures: 9,
    passes: 154,
    completed_passes: 145,
    left_foot_passes: 19,
    right_foot_passes: 124,
    player_shots_faced: 0
  },
  {
    match_id: 7175975,
    team_id: 468246,
    player_id: 19221,
    minutes_played: 128.55,
    team_possession_percentage: 0.78,
    xg: 0.05,
    shots: 1,
    goals: 1,
    tackles: 3,
    interceptions: 0,
    pressures: 6,
    passes: 180,
    completed_passes: 168,
    left_foot_passes: 21,
    right_foot_passes: 137,
    player_shots_faced: 0
  },
  {
    match_id: 7175975,
    team_id: 468226,
    player_id: 291054,
    minutes_played: 128.55,
    team_possession_percentage: 0.22,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 1,
    interceptions: 7,
    pressures: 7,
    passes: 33,
    completed_passes: 25,
    left_foot_passes: 4,
    right_foot_passes: 16,
    player_shots_faced: 0
  },
  {
    match_id: 7175976,
    team_id: 468244,
    player_id: 13387,
    minutes_played: 98.02,
    team_possession_percentage: 0.33,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 4,
    interceptions: 1,
    pressures: 6,
    passes: 30,
    completed_passes: 25,
    left_foot_passes: 6,
    right_foot_passes: 18,
    player_shots_faced: 0
  },
  {
    match_id: 7175976,
    team_id: 468230,
    player_id: 15297,
    minutes_played: 98.02,
    team_possession_percentage: 0.67,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 1,
    interceptions: 1,
    pressures: 4,
    passes: 55,
    completed_passes: 46,
    left_foot_passes: 4,
    right_foot_passes: 37,
    player_shots_faced: 0
  },
  {
    match_id: 7175976,
    team_id: 468230,
    player_id: 18164,
    minutes_played: 98.02,
    team_possession_percentage: 0.67,
    xg: 0.07,
    shots: 1,
    goals: 0,
    tackles: 3,
    interceptions: 2,
    pressures: 12,
    passes: 37,
    completed_passes: 30,
    left_foot_passes: 1,
    right_foot_passes: 23,
    player_shots_faced: 0
  },
  {
    match_id: 7175976,
    team_id: 468244,
    player_id: 18880,
    minutes_played: 75.33,
    team_possession_percentage: 0.33,
    xg: 0.29,
    shots: 3,
    goals: 2,
    tackles: 2,
    interceptions: 1,
    pressures: 17,
    passes: 13,
    completed_passes: 10,
    left_foot_passes: 1,
    right_foot_passes: 8,
    player_shots_faced: 0
  },
  {
    match_id: 7175976,
    team_id: 468244,
    player_id: 625230,
    minutes_played: 98.02,
    team_possession_percentage: 0.33,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 1,
    interceptions: 0,
    pressures: 19,
    passes: 24,
    completed_passes: 19,
    left_foot_passes: 2,
    right_foot_passes: 15,
    player_shots_faced: 0
  },
  {
    match_id: 7175976,
    team_id: 468244,
    player_id: 5558559,
    minutes_played: 82.17,
    team_possession_percentage: 0.33,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 1,
    interceptions: 0,
    pressures: 31,
    passes: 19,
    completed_passes: 14,
    left_foot_passes: 0,
    right_foot_passes: 11,
    player_shots_faced: 0
  },
  {
    match_id: 7175977,
    team_id: 468236,
    player_id: 4754,
    minutes_played: 85.55,
    team_possession_percentage: 0.41,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 0,
    interceptions: 0,
    pressures: 17,
    passes: 53,
    completed_passes: 34,
    left_foot_passes: 0,
    right_foot_passes: 22,
    player_shots_faced: 0
  },
  {
    match_id: 7175977,
    team_id: 468236,
    player_id: 6864,
    minutes_played: 96.23,
    team_possession_percentage: 0.41,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 0,
    interceptions: 0,
    pressures: 0,
    passes: 27,
    completed_passes: 20,
    left_foot_passes: 0,
    right_foot_passes: 19,
    player_shots_faced: 2
  },
  {
    match_id: 7175977,
    team_id: 468236,
    player_id: 7171,
    minutes_played: 65.87,
    team_possession_percentage: 0.41,
    xg: 0.02,
    shots: 1,
    goals: 0,
    tackles: 0,
    interceptions: 0,
    pressures: 26,
    passes: 17,
    completed_passes: 13,
    left_foot_passes: 0,
    right_foot_passes: 12,
    player_shots_faced: 0
  },
  {
    match_id: 7175977,
    team_id: 468236,
    player_id: 13912,
    minutes_played: 96.23,
    team_possession_percentage: 0.41,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 0,
    interceptions: 1,
    pressures: 13,
    passes: 46,
    completed_passes: 39,
    left_foot_passes: 2,
    right_foot_passes: 30,
    player_shots_faced: 0
  },
  {
    match_id: 7175977,
    team_id: 468236,
    player_id: 16826,
    minutes_played: 30.77,
    team_possession_percentage: 0.41,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 0,
    interceptions: 0,
    pressures: 7,
    passes: 5,
    completed_passes: 3,
    left_foot_passes: 1,
    right_foot_passes: 1,
    player_shots_faced: 0
  },
  {
    match_id: 7175977,
    team_id: 468236,
    player_id: 3304738,
    minutes_played: 96.23,
    team_possession_percentage: 0.41,
    xg: 0.2,
    shots: 2,
    goals: 0,
    tackles: 1,
    interceptions: 1,
    pressures: 43,
    passes: 18,
    completed_passes: 11,
    left_foot_passes: 3,
    right_foot_passes: 5,
    player_shots_faced: 0
  },
  {
    match_id: 7175981,
    team_id: 468217,
    player_id: 1121,
    minutes_played: 94.25,
    team_possession_percentage: 0.45,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 1,
    interceptions: 0,
    pressures: 18,
    passes: 31,
    completed_passes: 21,
    left_foot_passes: 3,
    right_foot_passes: 9,
    player_shots_faced: 0
  },
  {
    match_id: 7175981,
    team_id: 468217,
    player_id: 1181,
    minutes_played: 119.25,
    team_possession_percentage: 0.45,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 2,
    interceptions: 2,
    pressures: 15,
    passes: 63,
    completed_passes: 55,
    left_foot_passes: 1,
    right_foot_passes: 51,
    player_shots_faced: 0
  },
  {
    match_id: 7175981,
    team_id: 468217,
    player_id: 5647,
    minutes_played: 132.22,
    team_possession_percentage: 0.45,
    xg: 0.12,
    shots: 1,
    goals: 1,
    tackles: 1,
    interceptions: 1,
    pressures: 42,
    passes: 59,
    completed_passes: 39,
    left_foot_passes: 2,
    right_foot_passes: 22,
    player_shots_faced: 0
  },
  {
    match_id: 7175981,
    team_id: 468231,
    player_id: 16879,
    minutes_played: 132.22,
    team_possession_percentage: 0.55,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 0,
    interceptions: 0,
    pressures: 0,
    passes: 36,
    completed_passes: 29,
    left_foot_passes: 0,
    right_foot_passes: 16,
    player_shots_faced: 1
  },
  {
    match_id: 7175981,
    team_id: 468231,
    player_id: 21065,
    minutes_played: 98.43,
    team_possession_percentage: 0.55,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 1,
    interceptions: 0,
    pressures: 8,
    passes: 71,
    completed_passes: 48,
    left_foot_passes: 32,
    right_foot_passes: 6,
    player_shots_faced: 0
  },
  {
    match_id: 7175981,
    team_id: 468231,
    player_id: 24381,
    minutes_played: 132.22,
    team_possession_percentage: 0.55,
    xg: 0.53,
    shots: 7,
    goals: 1,
    tackles: 1,
    interceptions: 0,
    pressures: 27,
    passes: 44,
    completed_passes: 26,
    left_foot_passes: 12,
    right_foot_passes: 9,
    player_shots_faced: 0
  },
  {
    match_id: 7175981,
    team_id: 468217,
    player_id: 296172,
    minutes_played: 132.22,
    team_possession_percentage: 0.45,
    xg: 0.03,
    shots: 1,
    goals: 0,
    tackles: 0,
    interceptions: 1,
    pressures: 3,
    passes: 53,
    completed_passes: 46,
    left_foot_passes: 9,
    right_foot_passes: 32,
    player_shots_faced: 0
  },
  {
    match_id: 7175981,
    team_id: 468231,
    player_id: 299071,
    minutes_played: 27.18,
    team_possession_percentage: 0.55,
    xg: 0.2,
    shots: 3,
    goals: 0,
    tackles: 0,
    interceptions: 0,
    pressures: 2,
    passes: 13,
    completed_passes: 13,
    left_foot_passes: 1,
    right_foot_passes: 12,
    player_shots_faced: 0
  },
  {
    match_id: 7175981,
    team_id: 468217,
    player_id: 300386,
    minutes_played: 132.22,
    team_possession_percentage: 0.45,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 0,
    interceptions: 1,
    pressures: 55,
    passes: 46,
    completed_passes: 35,
    left_foot_passes: 5,
    right_foot_passes: 27,
    player_shots_faced: 0
  },
  {
    match_id: 7175982,
    team_id: 468240,
    player_id: 1593,
    minutes_played: 92.13,
    team_possession_percentage: 0.63,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 1,
    interceptions: 1,
    pressures: 10,
    passes: 80,
    completed_passes: 65,
    left_foot_passes: 9,
    right_foot_passes: 48,
    player_shots_faced: 0
  },
  {
    match_id: 7175982,
    team_id: 468227,
    player_id: 4190,
    minutes_played: 97.63,
    team_possession_percentage: 0.37,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 0,
    interceptions: 3,
    pressures: 20,
    passes: 45,
    completed_passes: 41,
    left_foot_passes: 7,
    right_foot_passes: 33,
    player_shots_faced: 0
  },
  {
    match_id: 7175982,
    team_id: 468227,
    player_id: 15983,
    minutes_played: 10.55,
    team_possession_percentage: 0.37,
    xg: 0.15,
    shots: 1,
    goals: 0,
    tackles: 0,
    interceptions: 0,
    pressures: 3,
    passes: 2,
    completed_passes: 2,
    left_foot_passes: 0,
    right_foot_passes: 2,
    player_shots_faced: 0
  },
  {
    match_id: 7175982,
    team_id: 468227,
    player_id: 19032,
    minutes_played: 97.63,
    team_possession_percentage: 0.37,
    xg: 0.04,
    shots: 1,
    goals: 0,
    tackles: 2,
    interceptions: 0,
    pressures: 15,
    passes: 32,
    completed_passes: 29,
    left_foot_passes: 1,
    right_foot_passes: 28,
    player_shots_faced: 0
  },
  {
    match_id: 7175982,
    team_id: 468227,
    player_id: 19204,
    minutes_played: 97.63,
    team_possession_percentage: 0.37,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 1,
    interceptions: 0,
    pressures: 6,
    passes: 39,
    completed_passes: 35,
    left_foot_passes: 11,
    right_foot_passes: 22,
    player_shots_faced: 0
  },
  {
    match_id: 7175982,
    team_id: 468227,
    player_id: 611277,
    minutes_played: 97.63,
    team_possession_percentage: 0.37,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 1,
    interceptions: 0,
    pressures: 8,
    passes: 33,
    completed_passes: 23,
    left_foot_passes: 2,
    right_foot_passes: 21,
    player_shots_faced: 0
  },
  {
    match_id: 7175983,
    team_id: 468227,
    player_id: 15970,
    minutes_played: 98.48,
    team_possession_percentage: 0.34,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 0,
    interceptions: 1,
    pressures: 7,
    passes: 22,
    completed_passes: 17,
    left_foot_passes: 14,
    right_foot_passes: 2,
    player_shots_faced: 0
  },
  {
    match_id: 7175983,
    team_id: 468231,
    player_id: 16879,
    minutes_played: 98.48,
    team_possession_percentage: 0.66,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 0,
    interceptions: 0,
    pressures: 0,
    passes: 10,
    completed_passes: 8,
    left_foot_passes: 0,
    right_foot_passes: 6,
    player_shots_faced: 5
  },
  {
    match_id: 7175983,
    team_id: 468231,
    player_id: 21065,
    minutes_played: 84.27,
    team_possession_percentage: 0.66,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 2,
    interceptions: 1,
    pressures: 7,
    passes: 28,
    completed_passes: 20,
    left_foot_passes: 15,
    right_foot_passes: 3,
    player_shots_faced: 0
  },
  {
    match_id: 7175983,
    team_id: 468231,
    player_id: 24381,
    minutes_played: 98.48,
    team_possession_percentage: 0.66,
    xg: 0.09,
    shots: 2,
    goals: 1,
    tackles: 4,
    interceptions: 1,
    pressures: 15,
    passes: 34,
    completed_passes: 18,
    left_foot_passes: 6,
    right_foot_passes: 11,
    player_shots_faced: 0
  },
  {
    match_id: 7175983,
    team_id: 468227,
    player_id: 288702,
    minutes_played: 98.48,
    team_possession_percentage: 0.34,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 1,
    interceptions: 1,
    pressures: 6,
    passes: 27,
    completed_passes: 17,
    left_foot_passes: 1,
    right_foot_passes: 10,
    player_shots_faced: 0
  },
  {
    match_id: 7175983,
    team_id: 468231,
    player_id: 299071,
    minutes_played: 24.65,
    team_possession_percentage: 0.66,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 0,
    interceptions: 0,
    pressures: 1,
    passes: 10,
    completed_passes: 10,
    left_foot_passes: 2,
    right_foot_passes: 8,
    player_shots_faced: 0
  },
  {
    match_id: 7175985,
    team_id: 468217,
    player_id: 1121,
    minutes_played: 112.57,
    team_possession_percentage: 0.52,
    xg: 0.04,
    shots: 1,
    goals: 0,
    tackles: 3,
    interceptions: 0,
    pressures: 7,
    passes: 44,
    completed_passes: 29,
    left_foot_passes: 4,
    right_foot_passes: 19,
    player_shots_faced: 0
  },
  {
    match_id: 7175985,
    team_id: 468217,
    player_id: 1181,
    minutes_played: 125.5,
    team_possession_percentage: 0.52,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 0,
    interceptions: 0,
    pressures: 3,
    passes: 59,
    completed_passes: 57,
    left_foot_passes: 3,
    right_foot_passes: 51,
    player_shots_faced: 0
  },
  {
    match_id: 7175985,
    team_id: 468217,
    player_id: 5647,
    minutes_played: 133.67,
    team_possession_percentage: 0.52,
    xg: 0.07,
    shots: 1,
    goals: 1,
    tackles: 6,
    interceptions: 2,
    pressures: 19,
    passes: 57,
    completed_passes: 35,
    left_foot_passes: 0,
    right_foot_passes: 26,
    player_shots_faced: 0
  },
  {
    match_id: 7175985,
    team_id: 468233,
    player_id: 5802,
    minutes_played: 133.67,
    team_possession_percentage: 0.48,
    xg: 0.01,
    shots: 1,
    goals: 0,
    tackles: 1,
    interceptions: 2,
    pressures: 15,
    passes: 64,
    completed_passes: 45,
    left_foot_passes: 29,
    right_foot_passes: 3,
    player_shots_faced: 0
  },
  {
    match_id: 7175985,
    team_id: 468233,
    player_id: 14909,
    minutes_played: 128,
    team_possession_percentage: 0.48,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 1,
    interceptions: 0,
    pressures: 21,
    passes: 48,
    completed_passes: 38,
    left_foot_passes: 2,
    right_foot_passes: 32,
    player_shots_faced: 0
  },
  {
    match_id: 7175985,
    team_id: 468233,
    player_id: 16556,
    minutes_played: 133.67,
    team_possession_percentage: 0.48,
    xg: 0.11,
    shots: 2,
    goals: 1,
    tackles: 0,
    interceptions: 0,
    pressures: 26,
    passes: 58,
    completed_passes: 48,
    left_foot_passes: 5,
    right_foot_passes: 40,
    player_shots_faced: 0
  },
  {
    match_id: 7175985,
    team_id: 468217,
    player_id: 296172,
    minutes_played: 133.67,
    team_possession_percentage: 0.52,
    xg: 0.11,
    shots: 3,
    goals: 0,
    tackles: 1,
    interceptions: 1,
    pressures: 1,
    passes: 80,
    completed_passes: 67,
    left_foot_passes: 10,
    right_foot_passes: 49,
    player_shots_faced: 0
  },
  {
    match_id: 7175985,
    team_id: 468217,
    player_id: 300386,
    minutes_played: 84.9,
    team_possession_percentage: 0.52,
    xg: 0.1,
    shots: 1,
    goals: 0,
    tackles: 1,
    interceptions: 0,
    pressures: 22,
    passes: 43,
    completed_passes: 35,
    left_foot_passes: 6,
    right_foot_passes: 25,
    player_shots_faced: 0
  },
  {
    match_id: 7175985,
    team_id: 468233,
    player_id: 5596276,
    minutes_played: 67.7,
    team_possession_percentage: 0.48,
    xg: 0.04,
    shots: 1,
    goals: 0,
    tackles: 2,
    interceptions: 0,
    pressures: 10,
    passes: 13,
    completed_passes: 7,
    left_foot_passes: 0,
    right_foot_passes: 7,
    player_shots_faced: 0
  },
  {
    match_id: 7175993,
    team_id: 468243,
    player_id: 6971,
    minutes_played: 96.18,
    team_possession_percentage: 0.51,
    xg: 0.03,
    shots: 1,
    goals: 0,
    tackles: 3,
    interceptions: 0,
    pressures: 8,
    passes: 64,
    completed_passes: 58,
    left_foot_passes: 10,
    right_foot_passes: 44,
    player_shots_faced: 0
  },
  {
    match_id: 7175993,
    team_id: 468237,
    player_id: 8586,
    minutes_played: 90.88,
    team_possession_percentage: 0.49,
    xg: 0.08,
    shots: 2,
    goals: 0,
    tackles: 2,
    interceptions: 1,
    pressures: 24,
    passes: 47,
    completed_passes: 33,
    left_foot_passes: 1,
    right_foot_passes: 30,
    player_shots_faced: 0
  },
  {
    match_id: 7175993,
    team_id: 468237,
    player_id: 12256,
    minutes_played: 96.18,
    team_possession_percentage: 0.49,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 5,
    interceptions: 0,
    pressures: 25,
    passes: 50,
    completed_passes: 44,
    left_foot_passes: 4,
    right_foot_passes: 38,
    player_shots_faced: 0
  },
  {
    match_id: 7175993,
    team_id: 468243,
    player_id: 12504,
    minutes_played: 96.18,
    team_possession_percentage: 0.51,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 0,
    interceptions: 0,
    pressures: 0,
    passes: 14,
    completed_passes: 10,
    left_foot_passes: 1,
    right_foot_passes: 8,
    player_shots_faced: 10
  },
  {
    match_id: 7175993,
    team_id: 468237,
    player_id: 18673,
    minutes_played: 96.18,
    team_possession_percentage: 0.49,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 1,
    interceptions: 1,
    pressures: 1,
    passes: 43,
    completed_passes: 38,
    left_foot_passes: 0,
    right_foot_passes: 37,
    player_shots_faced: 0
  },
  {
    match_id: 7175993,
    team_id: 468243,
    player_id: 19881,
    minutes_played: 96.18,
    team_possession_percentage: 0.51,
    xg: 0.06,
    shots: 2,
    goals: 0,
    tackles: 4,
    interceptions: 0,
    pressures: 5,
    passes: 31,
    completed_passes: 26,
    left_foot_passes: 22,
    right_foot_passes: 2,
    player_shots_faced: 0
  },
  {
    match_id: 7175993,
    team_id: 468237,
    player_id: 20619,
    minutes_played: 10.25,
    team_possession_percentage: 0.49,
    xg: 0.83,
    shots: 1,
    goals: 1,
    tackles: 3,
    interceptions: 0,
    pressures: 10,
    passes: 6,
    completed_passes: 3,
    left_foot_passes: 1,
    right_foot_passes: 1,
    player_shots_faced: 0
  },
  {
    match_id: 7175993,
    team_id: 468243,
    player_id: 20934,
    minutes_played: 96.18,
    team_possession_percentage: 0.51,
    xg: 0.06,
    shots: 2,
    goals: 0,
    tackles: 2,
    interceptions: 0,
    pressures: 12,
    passes: 45,
    completed_passes: 37,
    left_foot_passes: 30,
    right_foot_passes: 1,
    player_shots_faced: 0
  },
  {
    match_id: 7175993,
    team_id: 468237,
    player_id: 625403,
    minutes_played: 96.18,
    team_possession_percentage: 0.49,
    xg: 0.25,
    shots: 3,
    goals: 0,
    tackles: 2,
    interceptions: 0,
    pressures: 40,
    passes: 21,
    completed_passes: 15,
    left_foot_passes: 2,
    right_foot_passes: 11,
    player_shots_faced: 0
  },
  {
    match_id: 7175993,
    team_id: 468243,
    player_id: 5577288,
    minutes_played: 96.18,
    team_possession_percentage: 0.51,
    xg: 0.04,
    shots: 1,
    goals: 0,
    tackles: 4,
    interceptions: 1,
    pressures: 24,
    passes: 48,
    completed_passes: 45,
    left_foot_passes: 38,
    right_foot_passes: 4,
    player_shots_faced: 0
  },
  {
    match_id: 7175937,
    team_id: 468245,
    player_id: 1240,
    minutes_played: 80.43,
    team_possession_percentage: 0.47,
    xg: 0.09,
    shots: 3,
    goals: 0,
    tackles: 0,
    interceptions: 3,
    pressures: 11,
    passes: 49,
    completed_passes: 41,
    left_foot_passes: 0,
    right_foot_passes: 38,
    player_shots_faced: 0
  },
  {
    match_id: 7175937,
    team_id: 468245,
    player_id: 3566,
    minutes_played: 59.88,
    team_possession_percentage: 0.47,
    xg: 0.12,
    shots: 2,
    goals: 0,
    tackles: 0,
    interceptions: 0,
    pressures: 10,
    passes: 16,
    completed_passes: 11,
    left_foot_passes: 2,
    right_foot_passes: 7,
    player_shots_faced: 0
  },
  {
    match_id: 7175937,
    team_id: 468245,
    player_id: 3575,
    minutes_played: 67.73,
    team_possession_percentage: 0.47,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 0,
    interceptions: 0,
    pressures: 11,
    passes: 11,
    completed_passes: 7,
    left_foot_passes: 4,
    right_foot_passes: 1,
    player_shots_faced: 0
  },
  {
    match_id: 7175937,
    team_id: 468245,
    player_id: 14636,
    minutes_played: 24.63,
    team_possession_percentage: 0.47,
    xg: 0,
    shots: 0,
    goals: 1,
    tackles: 0,
    interceptions: 0,
    pressures: 5,
    passes: 11,
    completed_passes: 11,
    left_foot_passes: 1,
    right_foot_passes: 10,
    player_shots_faced: 0
  },
  {
    match_id: 7175937,
    team_id: 468231,
    player_id: 16879,
    minutes_played: 127.62,
    team_possession_percentage: 0.53,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 0,
    interceptions: 0,
    pressures: 0,
    passes: 34,
    completed_passes: 22,
    left_foot_passes: 1,
    right_foot_passes: 12,
    player_shots_faced: 3
  },
  {
    match_id: 7175937,
    team_id: 468231,
    player_id: 21065,
    minutes_played: 82.42,
    team_possession_percentage: 0.53,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 1,
    interceptions: 1,
    pressures: 9,
    passes: 54,
    completed_passes: 37,
    left_foot_passes: 23,
    right_foot_passes: 2,
    player_shots_faced: 0
  },
  {
    match_id: 7175937,
    team_id: 468231,
    player_id: 24381,
    minutes_played: 101.95,
    team_possession_percentage: 0.53,
    xg: 0.39,
    shots: 7,
    goals: 0,
    tackles: 0,
    interceptions: 2,
    pressures: 16,
    passes: 21,
    completed_passes: 15,
    left_foot_passes: 3,
    right_foot_passes: 8,
    player_shots_faced: 0
  },
  {
    match_id: 7175937,
    team_id: 468231,
    player_id: 299071,
    minutes_played: 25.93,
    team_possession_percentage: 0.53,
    xg: 0.03,
    shots: 1,
    goals: 1,
    tackles: 0,
    interceptions: 1,
    pressures: 7,
    passes: 15,
    completed_passes: 12,
    left_foot_passes: 3,
    right_foot_passes: 8,
    player_shots_faced: 0
  },
  {
    match_id: 7175942,
    team_id: 468237,
    player_id: 5116,
    minutes_played: 22.98,
    team_possession_percentage: 0.58,
    xg: 0.35,
    shots: 2,
    goals: 1,
    tackles: 0,
    interceptions: 0,
    pressures: 4,
    passes: 9,
    completed_passes: 7,
    left_foot_passes: 1,
    right_foot_passes: 6,
    player_shots_faced: 0
  },
  {
    match_id: 7175942,
    team_id: 468240,
    player_id: 8183,
    minutes_played: 96.3,
    team_possession_percentage: 0.42,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 1,
    interceptions: 0,
    pressures: 44,
    passes: 37,
    completed_passes: 33,
    left_foot_passes: 0,
    right_foot_passes: 33,
    player_shots_faced: 0
  },
  {
    match_id: 7175942,
    team_id: 468237,
    player_id: 9279,
    minutes_played: 96.3,
    team_possession_percentage: 0.58,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 0,
    interceptions: 0,
    pressures: 0,
    passes: 7,
    completed_passes: 6,
    left_foot_passes: 0,
    right_foot_passes: 4,
    player_shots_faced: 3
  },
  {
    match_id: 7175942,
    team_id: 468237,
    player_id: 10767,
    minutes_played: 96.3,
    team_possession_percentage: 0.58,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 1,
    interceptions: 1,
    pressures: 24,
    passes: 39,
    completed_passes: 35,
    left_foot_passes: 4,
    right_foot_passes: 26,
    player_shots_faced: 0
  },
  {
    match_id: 7175942,
    team_id: 468240,
    player_id: 13421,
    minutes_played: 96.3,
    team_possession_percentage: 0.42,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 1,
    interceptions: 0,
    pressures: 14,
    passes: 29,
    completed_passes: 25,
    left_foot_passes: 5,
    right_foot_passes: 20,
    player_shots_faced: 0
  },
  {
    match_id: 7175942,
    team_id: 468240,
    player_id: 17198,
    minutes_played: 96.3,
    team_possession_percentage: 0.42,
    xg: 0.06,
    shots: 1,
    goals: 0,
    tackles: 5,
    interceptions: 3,
    pressures: 63,
    passes: 35,
    completed_passes: 28,
    left_foot_passes: 8,
    right_foot_passes: 17,
    player_shots_faced: 0
  },
  {
    match_id: 7175942,
    team_id: 468237,
    player_id: 19246,
    minutes_played: 96.3,
    team_possession_percentage: 0.58,
    xg: 0.02,
    shots: 1,
    goals: 0,
    tackles: 1,
    interceptions: 2,
    pressures: 9,
    passes: 80,
    completed_passes: 66,
    left_foot_passes: 52,
    right_foot_passes: 8,
    player_shots_faced: 0
  },
  {
    match_id: 7175944,
    team_id: 468240,
    player_id: 1593,
    minutes_played: 38.63,
    team_possession_percentage: 0.42,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 1,
    interceptions: 0,
    pressures: 18,
    passes: 11,
    completed_passes: 11,
    left_foot_passes: 3,
    right_foot_passes: 5,
    player_shots_faced: 0
  },
  {
    match_id: 7175944,
    team_id: 468217,
    player_id: 5525,
    minutes_played: 48.07,
    team_possession_percentage: 0.58,
    xg: 0.04,
    shots: 2,
    goals: 0,
    tackles: 1,
    interceptions: 1,
    pressures: 19,
    passes: 39,
    completed_passes: 34,
    left_foot_passes: 1,
    right_foot_passes: 33,
    player_shots_faced: 0
  },
  {
    match_id: 7175944,
    team_id: 468240,
    player_id: 10784,
    minutes_played: 95.18,
    team_possession_percentage: 0.42,
    xg: 0.49,
    shots: 2,
    goals: 1,
    tackles: 0,
    interceptions: 2,
    pressures: 18,
    passes: 38,
    completed_passes: 29,
    left_foot_passes: 2,
    right_foot_passes: 25,
    player_shots_faced: 0
  },
  {
    match_id: 7175944,
    team_id: 468217,
    player_id: 16419,
    minutes_played: 47.12,
    team_possession_percentage: 0.58,
    xg: 0.06,
    shots: 2,
    goals: 0,
    tackles: 0,
    interceptions: 1,
    pressures: 10,
    passes: 25,
    completed_passes: 23,
    left_foot_passes: 0,
    right_foot_passes: 23,
    player_shots_faced: 0
  },
  {
    match_id: 7175944,
    team_id: 468217,
    player_id: 16931,
    minutes_played: 95.18,
    team_possession_percentage: 0.58,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 1,
    interceptions: 2,
    pressures: 19,
    passes: 71,
    completed_passes: 64,
    left_foot_passes: 2,
    right_foot_passes: 58,
    player_shots_faced: 0
  },
  {
    match_id: 7175946,
    team_id: 468227,
    player_id: 12893,
    minutes_played: 97.05,
    team_possession_percentage: 0.4,
    xg: 0.06,
    shots: 1,
    goals: 0,
    tackles: 2,
    interceptions: 0,
    pressures: 36,
    passes: 14,
    completed_passes: 9,
    left_foot_passes: 5,
    right_foot_passes: 0,
    player_shots_faced: 0
  },
  {
    match_id: 7175946,
    team_id: 468239,
    player_id: 13942,
    minutes_played: 97.05,
    team_possession_percentage: 0.6,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 4,
    interceptions: 3,
    pressures: 17,
    passes: 60,
    completed_passes: 51,
    left_foot_passes: 3,
    right_foot_passes: 48,
    player_shots_faced: 0
  },
  {
    match_id: 7175946,
    team_id: 468239,
    player_id: 17938,
    minutes_played: 47,
    team_possession_percentage: 0.6,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 0,
    interceptions: 3,
    pressures: 4,
    passes: 25,
    completed_passes: 25,
    left_foot_passes: 23,
    right_foot_passes: 2,
    player_shots_faced: 0
  },
  {
    match_id: 7175946,
    team_id: 468227,
    player_id: 18811,
    minutes_played: 76.77,
    team_possession_percentage: 0.4,
    xg: 0.07,
    shots: 1,
    goals: 0,
    tackles: 4,
    interceptions: 1,
    pressures: 37,
    passes: 28,
    completed_passes: 24,
    left_foot_passes: 23,
    right_foot_passes: 0,
    player_shots_faced: 0
  },
  {
    match_id: 7175946,
    team_id: 468227,
    player_id: 19562,
    minutes_played: 97.05,
    team_possession_percentage: 0.4,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 0,
    interceptions: 0,
    pressures: 0,
    passes: 24,
    completed_passes: 17,
    left_foot_passes: 10,
    right_foot_passes: 2,
    player_shots_faced: 4
  },
  {
    match_id: 7175946,
    team_id: 468239,
    player_id: 292628,
    minutes_played: 97.05,
    team_possession_percentage: 0.6,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 3,
    interceptions: 1,
    pressures: 25,
    passes: 29,
    completed_passes: 25,
    left_foot_passes: 17,
    right_foot_passes: 0,
    player_shots_faced: 0
  },
  {
    match_id: 7175951,
    team_id: 468240,
    player_id: 8183,
    minutes_played: 96.25,
    team_possession_percentage: 0.58,
    xg: 0.07,
    shots: 2,
    goals: 0,
    tackles: 2,
    interceptions: 2,
    pressures: 15,
    passes: 64,
    completed_passes: 60,
    left_foot_passes: 2,
    right_foot_passes: 54,
    player_shots_faced: 0
  },
  {
    match_id: 7175951,
    team_id: 468240,
    player_id: 13421,
    minutes_played: 96.25,
    team_possession_percentage: 0.58,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 0,
    interceptions: 0,
    pressures: 8,
    passes: 76,
    completed_passes: 68,
    left_foot_passes: 7,
    right_foot_passes: 58,
    player_shots_faced: 0
  },
  {
    match_id: 7175951,
    team_id: 468241,
    player_id: 14810,
    minutes_played: 96.25,
    team_possession_percentage: 0.42,
    xg: 0,
    shots: 0,
    goals: 0,
    tackles: 0,
    interceptions: 0,
    pressures: 0,
    passes: 27,
    completed_passes: 15,
    left_foot_passes: 1,
    right_foot_passes: 12,
    player_shots_faced: 7
  },
  {
    match_id: 7175951,
    team_id: 468240,
    player_id: 17198,
    minutes_played: 30.82,
    team_possession_percentage: 0.58,
    xg: 0.09,
    shots: 1,
    goals: 1,
    tackles: 0,
    interceptions: 0,
    pressures: 9,
    passes: 13,
    completed_passes: 11,
    left_foot_passes: 2,
    right_foot_passes: 8,
    player_shots_faced: 0
  }
]

export default StatData
